export default __webpack_public_path__ + "static/media/ushna.906401f3.png";